import moment from "moment";
import { timeRangeTypeEnum } from "constants/consts";

export const substractTime = (startDate, periodInSeconds) => {
  const periodInMiliseconds = periodInSeconds * 1000;
  return startDate - periodInMiliseconds;
};

export const getPeriodOfTimeInSeconds = (value, unit) => {
  return Math.ceil(
    (moment().format("x") -
      moment()
        .subtract(value, unit)
        .format("x")) /
      1000
  );
};

export const getTimeRange = (
  type,
  currentDate,
  duration,
  timeShiftSelected
) => {
  switch (type) {
    case timeRangeTypeEnum.CURRENT:
      return {
        end: currentDate,
        start: substractTime(currentDate, duration),
      };
    case timeRangeTypeEnum.SHIFTED:
      return {
        end: substractTime(currentDate, timeShiftSelected),
        start: substractTime(currentDate, duration + timeShiftSelected),
      };
  }
};

export const toISOString = timestamp => moment(timestamp * 1000).toISOString();
export const toSeconds = timestamp => Math.round(timestamp / 1000);
